module.exports = __webpack_public_path__ + "img/logo.fad79974.png";